/*
Poornima 09/19/2022 2701127043 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
akhila 10/27/2022 2701127043 bre UX Changes
suresh peddavoora 10/28/2022 2701127043  Modified styles for tabs section
Ashraf 11/14/2022 2701127043 fixed bre role issue
Sai Maheshwar 12/16/2022 2701127043 add accordion for function usage

*/
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
// import AddRuleGroup from "./AddRuleGroup";
import StepperRuleGroup from './StepperRuleGroup';
import SearchRuleGroup from './SearchRuleGroup';
import UsageFormulaRuleGroup from './Usage';
import {useSelector} from 'react-redux';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'subContent': {
    '& .MuiCard-root': {
      boxShadow: 'none !important',
    },
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function RuleGroupTabs({groupId, RMbreCode, setTabValue}) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [fieldRowData, setFieldRowData] = useState('');
  const [usageState, setUsageState] = useState(false);
  const [breCode, setBreCode] = useState(null);
  const [dataReset, setResetData] = useState('');
  const [roleDataBre, setRoleDataBre] = useState({});
  const {roleData} = useSelector(({role}) => role);
  const [rowSelected, setRowSelected] = useState(false);
  const [editExisting, setEditExisting] = useState();

  useEffect(() => {
    if (groupId !== '') {
      setValue(1);
    }
  }, [groupId]);
  useEffect(() => {
    if (RMbreCode !== null) {
      setBreCode(RMbreCode);
    }
  }, [RMbreCode]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    setRoleDataBre(roleData ? roleData?.window?.['Business Rule Engine']?.BR : {});
  }, [roleData]);
  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchRuleGroup
            roleDataBre={roleDataBre}
            setRoleDataBre={setRoleDataBre}
            usageState={usageState}
            dataReset={dataReset}
            setValue={setValue}
            setFieldRowData={setFieldRowData}
            fieldRowData={fieldRowData}
            setUsageState={setUsageState}
            setBreCode={setBreCode}
            setResetData={setResetData}
            setRowSelected={setRowSelected}
            setEditExisting={setEditExisting}
          />
        ) : value === 1 ? (
          <StepperRuleGroup
            setValue={setValue}
            setUsageState={setUsageState}
            setBreCode={setBreCode}
            breCode={breCode}
            setTabValue={setTabValue}
            dataReset={dataReset}
            roleDataBre={roleDataBre}
            setRoleDataBre={setRoleDataBre}
            rowSelected={rowSelected}
            editExisting={editExisting}
            handleChange={handleChange}
          />
        ) : value === 2 ? (
          <UsageFormulaRuleGroup
            setUsageState={setUsageState}
            fieldRowData={fieldRowData}
            setValue={setValue}
          />
        ) : null}
      </div>
    </div>
  );
}
